"use strict";

exports.__esModule = true;
var _TimelineQueryController = require("./TimelineQueryController");
Object.keys(_TimelineQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimelineQueryController[key]) return;
  exports[key] = _TimelineQueryController[key];
});